import React from "react";
import { Typography } from "@picklebet/ui";
import { constructCurrency } from "common/currency";
import { SupportLink } from "features/shell/components/shared/SupportLink";
import { useMaxDepositAmount } from "features/wallet/hooks/useMaxDepositAmount";
import { useFiatCurrency } from "hooks/firestore/user/useFiatCurrency";

import * as styles from "./MaxDeposit.module.scss";

export const MaxDeposit = ({ supportLabel }: { supportLabel: string }) => {
  const currency = useFiatCurrency();
  const { maxDepositAmount, isLoading } = useMaxDepositAmount();

  return (
    <div className={styles.container}>
      <Typography
        noSpacing
        className={styles.label}
        skeleton={{ loading: isLoading }}
      >
        Max Deposit:{" "}
        {constructCurrency(maxDepositAmount, { currencyType: currency })}
      </Typography>

      <SupportLink
        className={styles.supportLink}
        hideChevron
        options={{ labels: [supportLabel] }}
      >
        Learn More
      </SupportLink>
    </div>
  );
};
